export const mapListPagePieData = (
	items: Array<{ label: string; value: number; percent?: number }> = []
) =>
	items.map((item) => ({
		name: item.label,
		value: item.value,
		percent: item.percent,
	}));

export const mapListPageLineChart = (line?: {
	period: string;
	growthPercentage: number;
	subtitle: string;
	data: Array<{ label: string; current: number; previous: number }>;
}) => {
	const growth = line?.growthPercentage ?? 0;

	return {
		lineData:
			line?.data.map((item) => ({
				day: item.label,
				atual: item.current,
				anterior: item.previous,
			})) ?? [],
		mainValue: line?.subtitle ?? '0',
		trendValue: `${Math.abs(growth)}%`,
		trendDirection: (growth >= 0 ? 'up' : 'down') as 'up' | 'down',
		footerText: line?.period ? `Inserções de ${line.period}` : '',
	};
};
